import React, { useState } from 'react';
import styles from '../CreateParameterPopup.module.css'
import { useTranslation } from 'react-i18next';
import {ReactComponent as PencilEdit} from '../../../assets/pencilEdit.svg'
import LabelParameters from '../LabelParameters';
const NumberComponent = ({parameterData, handleChange,editingInput,setEditingInput}) => {
  const [t] = useTranslation("Contacts");

  return (
<LabelParameters value={parameterData.number} text={'number'} editingInput={editingInput} setEditingInput={setEditingInput}>
<input
          type="number"
          value={parameterData?.number}
          name={'number'}
          onChange={handleChange}
          placeholder='00.00'
        />
</LabelParameters>
  );
};

export default NumberComponent;
